import { getValidExternalUrl } from './getValidExternalUrl';

export const getLinkHref = (url?: string) => url ? getValidExternalUrl(url) : '';
